/**
 * `09:30:00` from the API as `09:30` for a `<select>` value.
 *
 * FastAPI serialises a `datetime.time` with seconds and the options here do not
 * carry them, so without this every value arrives unmatched and both selects
 * render blank — showing a tenant an empty window over a server that has one.
 */
export function trimSeconds(time: string): string {
  return time.slice(0, 5)
}

/**
 * Every half hour of the day, as `HH:MM`.
 *
 * `23:30` is the last entry rather than `23:59`, which means the *literal*
 * always-on window `app/linkedin/send_window.py` describes is not selectable
 * here. That is deliberate: 00:00 to 23:30 differs from around-the-clock by half
 * an hour at the quietest end of the night, nobody schedules outreach in it, and
 * the alternative is one odd option in a list of forty-eight that exists only to
 * express *turn this protection off*. A tenant who genuinely needs it can be set
 * up by support against the API.
 */
export const TIMES: readonly string[] = Array.from({ length: 48 }, (_, index) => {
  const hour = Math.floor(index / 2)
  const minute = index % 2 === 0 ? '00' : '30'
  return `${String(hour).padStart(2, '0')}:${minute}`
})
